import { StandardEvents } from '@shopify/events';

/**
 * <amq-product-variant-weight>: "Gewicht der Variante 90 cm x 200 cm: 26 kg" in the "Aufbau"
 * accordion (blocks/amq_product_variant_weight.liquid).
 *
 * Same pattern as assets/amq_product_cents_per_night.js: Horizon morphs only the variant picker on a
 * variant change, so this element takes its content from the matching element in the section HTML
 * the picker fetched. After a switch to another model the picker fetches that model's section, so
 * the weight is the model's. The switch itself is handled by the model switcher (SWAPPED_ELEMENTS).
 */
class AmqProductVariantWeight extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {CustomEvent & { promise?: Promise<{ detail?: { html?: Document } }> }} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;

    event.promise
      .then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;

        const next = html.querySelector(`amq-product-variant-weight[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        this.innerHTML = next.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[amq-product-variant-weight]', error);
      });
  };
}

if (!customElements.get('amq-product-variant-weight')) {
  customElements.define('amq-product-variant-weight', AmqProductVariantWeight);
}
